import { useMutation, useQueryClient } from "@tanstack/react-query";

import { PROMOTION_CACHE_KEYS } from "./keys";

import { PromotionRepository } from "@/repositories/promotion";
import { CreatePromotion } from "@/types";

const promotionRepository = new PromotionRepository();

export const useCreatePromotion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePromotion) => promotionRepository.create(data),
    onSuccess: (promotion) => {
      queryClient.setQueryData(
        PROMOTION_CACHE_KEYS.DETAIL(promotion.id),
        promotion,
      );
      queryClient.invalidateQueries({ queryKey: PROMOTION_CACHE_KEYS.LISTS });
    },
  });
};
